module.exports = __webpack_public_path__ + "assets/26c6b90f004ba3f82b872e10b28cae5a.png";